// Enviroment variables
const DEV = process.env.NODE_ENV === 'development'
// const baseURL = DEV ? 'http://127.0.0.1:8000' : 'https://diyinbound-pre.herokuapp.com'
const baseURL = DEV ? 'http://127.0.0.1:8000' : '/'

export default { baseURL, DEV }
